import { useQuery } from '@tanstack/react-query';

import { searchClients } from '@/features/clients/api/clients';

export function useClients(query: string) {
  return useQuery({
    queryKey: ['clients', query],
    queryFn: () => searchClients(query),
  });
}
